import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import CompanyInfoContainer from '../../containers/companyinfomng/CompanyInfoContainer';
import DocuRuleContainer from '../../containers/companyinfomng/DocuRuleContainer';

const CompanyInfoPage = () => {
  const [tab, setTab] = useState(0);

  return (
    <div>
      <BreadcrumbsContainer
        title="시스템관리/회사정보설정"
        icon="business"
      />

      <Box sx={{ mx: 1 }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab label="회사 정보" />
          <Tab label="문서번호" />
        </Tabs>
      </Box>

      {tab === 0 && <CompanyInfoContainer />}
      {tab === 1 && <DocuRuleContainer />}
    </div>
  );
};

export default CompanyInfoPage;
